import { QuantityLabel, SANStorageType } from './enums'
import { ProjectType, SiteType, SiteDesignType } from './types'

export const formatMainDataDates = <T extends ProjectType | SiteType | SiteDesignType>(mainDataDates: T[]): T[] => {
  mainDataDates.forEach(p => {
    p.formattedCreatedUtc = toShortDate(p.createdDate)
    p.formattedUpdatedUtc = toShortDate(p.updatedDate)
  })
  return mainDataDates
}

export const toShortDate = (dateString: string): string => {
  if (!dateString) return ''

  const date = new Date(dateString)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = date.getFullYear()
  return `${dd}/${mm}/${yyyy}`
}

export const enumToOptionList = <EnumType>(enumType: EnumType): { label: string; value: string }[] =>
  Object.values(enumType)
    .filter(value => !value.includes(':hidden'))
    .map(key => ({ label: key, value: key }))

export const toCamelCase = (inputName: string): string => {
  return inputName.toLowerCase().replace(/\s+(\w)/g, (_match, p1) => p1.toUpperCase())
}

export const isNameLengthTooLong = (name: string, maxLength: number): boolean => {
  return name.length > maxLength
}

export const getQuantityLabel = (connectivity: string): QuantityLabel => {
  const isSANConnectivity = (_connectivity?: string): boolean => {
    return _connectivity === SANStorageType.iSCSISAN || _connectivity === SANStorageType.FibreChannelSAN
  }

  return isSANConnectivity(connectivity) ? QuantityLabel.Quantity : QuantityLabel.QuantityPerServer
}
